module.exports = __webpack_public_path__ + "media/images/client-30-db57956a4301c341e29566eb40a6f933.png";